module.exports = __webpack_public_path__ + "static/img/luobo_shunshun.5899a16.92f34ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/luobo_shunshun.5899a16.png
// module id = Pf4S
// module chunks = 1